export const filters = [
  { name: 'timeRange', backendName: 'time_range' },
  { name: 'regionId', backendName: 'region_id' },
  { name: 'groupBy', backendName: 'group_by' },
  { name: 'variantId', backendName: 'variant_id' },
  { name: 'transactionType', backendName: 'transaction_type' },
  { name: 'reasonId', backendName: 'return_reason_id' },
  { name: 'subReasonId', backendName: 'subreason_id' },
  { name: 'categoryId', backendName: 'product_type' },
  { name: 'typeId', backendName: 'category' },
  { name: 'collectionId', backendName: 'collection_id' },
  { name: 'ordering', backendName: 'ordering' },
  { name: 'startDate', backendName: 'start_date' },
  { name: 'endDate', backendName: 'end_date' },
  { name: 'query', backendName: 'query' },
  { name: 'timeDisplayReturnSales', backendName: 'time_display' },
  { name: 'timeDisplayReturnsExchanges', backendName: 'time_display' },
]

export const orderingTitles = {
  sales: 'ventas',
  ratio: 'tasa de devolución',
  returns: 'devoluciones',
}
